export default __webpack_public_path__ + "static/media/datatrust.03011fac.png";